/**
 * Simple encryption/decryption for URL IDs
 * This provides a clean string in the URL instead of raw numeric IDs
 */

const SALT = "biz_";

export const encryptId = (id) => {
  if (!id) return "";
  try {
    // Convert to string, add salt, and Base64 encode
    const str = `${SALT}${id}`;
    return btoa(str).replace(/=/g, ""); // Remove padding for cleaner URLs
  } catch (e) {
    return id.toString();
  }
};

export const decryptId = (encryptedId) => {
  if (!encryptedId) return "";
  try {
    // Re-add padding if needed and decode
    let str = encryptedId;
    while (str.length % 4 !== 0) str += "=";
    const decoded = atob(str);

    // Remove salt and return original ID
    if (decoded.startsWith(SALT)) {
      return decoded.replace(SALT, "");
    }
    return decoded;
  } catch (e) {
    return encryptedId;
  }
};

/**
 * Resolves a relative path from the backend into a full URL
 * @param {string} path - The relative path (e.g., /Documents/Trainers/img.jpg)
 * @returns {string} - The full URL
 */
export const resolveImagePath = (path) => {
  if (!path || path === "null" || path === "undefined") return null;
  if (typeof path !== "string") return null;
  if (path.startsWith("http") || path.startsWith("data:") || path.startsWith("blob:")) return path;

  const baseUrl = import.meta.env.VITE_API_BASE_URL || "";
  // Ensure we don't have double slashes
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${baseUrl}${normalizedPath}`;
};
